export const sentry = {
  development: 'https://d922a8600b9f4f9a8a32d884f405b891@o29226.ingest.sentry.io/4505464698044416',
  production: 'https://b4f29850fd954c708eaae46dc4f41619@o29226.ingest.sentry.io/4505464696078336'
}

export const LOCALE = {
  VITE_BASE_URL:'/',
  VITE_DEFAULT_LOCALE: 'en',
  VITE_FALLBACK_LOCALE: 'ms',
  VITE_SUPPORTED_LOCALES:'en,zh,ms'
}

export const environment = {
  isProduction: process.env.NODE_ENV === 'production'
}
